<template>
  <a :href="url" class="button button--secondary button--full-width extras-mg-google">
    <img :src="icon" alt="" class="extras-mg-google__icono" />
    <span>Entrar con {{ name }}</span>
  </a>
</template>

<script>
/**
 * El botón de "Entrar con Google". Si la persona llegó desde una invitación,
 * la invitación viaja con ella: al volver de Google entra ya al espacio.
 */
export default {
  name: 'BotonGoogle',
  props: {
    redirectUrl: { type: String, required: true },
    name: { type: String, default: 'Google' },
    icon: { type: String, default: '' },
    small: { type: Boolean, default: false },
    invitation: { type: Object, default: null },
  },
  computed: {
    url() {
      const token = this.$route.query.workspaceInvitationToken
      if (!token) return this.redirectUrl
      const url = new URL(this.redirectUrl)
      url.searchParams.append('workspace_invitation_token', token)
      return url.toString()
    },
  },
}
</script>

<style lang="scss">
.extras-mg-google {
  gap: 10px;
  justify-content: center;
}

.extras-mg-google__icono {
  height: 18px;
  width: 18px;
}
</style>
